export default "__VITE_ASSET__Buk3glbr__"